import React from "react";
import { Link } from "react-router-dom";

export const UiFormFooter = (props) => {
    return (
        <>
            <div className="sb-form-footer">
               {props.text} <Link to={props.link}>{props.linkText}</Link>
            </div>
        </>
    )
}